/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_MenuInputs */



/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Layout_Header_MenuInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_menu = /** @type {((inputs?: Layout_Header_MenuInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_MenuInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Menü")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Menu")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("菜单")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("選單")
	if (locale === "ko") return /** @type {LocalizedString} */ ("메뉴")
	return /** @type {LocalizedString} */ ("Menu")
});